export default {
    title_list: 'Email subscriptions',
    title_page: 'Email subscription',
    title_create_page: 'Create email subscription',
    title_edit_page: 'Change email subscription',

    filter: {
        labels: {
           email: 'Email',
           type: 'Type',
            decluttering_and_downsizing: 'Decluttering & downsizing',
            estate_planning: 'Estate planning',
            geneaology_and_family_history: 'Genealogy & family history',
            insurance: 'Insurance',
            tips_and_tricks: 'Tips & tricks',
        }
    },

    table: {
        labels: {
            id: 'ID',
            email: 'Email',
            type: 'Type',
            created_at: 'Created at',
            decluttering_and_downsizing: 'Decluttering & downsizing',
            estate_planning: 'Estate planning',
            geneaology_and_family_history: 'Genealogy & family history',
            insurance: 'Insurance',
            tips_and_tricks: 'Tips & tricks',

        }
    },

    buttons: {
    },

    form: {
        email: 'Email',
        type: 'Type',
    },
}
